import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const employeesSlider = document.querySelector('.employees-slider');

export function calculateSlidesPerView() {
    let perView = 4;
    if (window.innerWidth < 1024) {
        perView = 1;
    }
    return perView;
}

export default function initEmployeesSlider() {
    if (employeesSlider) {
    // eslint-disable-next-line no-new
        const employeesSwiper = new Swiper('.employees-slider', {
            slidesPerView: calculateSlidesPerView(),
            direction: 'horizontal',
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        window.addEventListener('resize', (event) => {
            employeesSwiper.params.slidesPerView = calculateSlidesPerView();
            employeesSwiper.update();
        }, true);
    }
}
